import { Injectable } from '@angular/core';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private apiHelper: ApiHelper) { }

  login(userName: string, password: string) {
    return this.apiHelper.post("/api/auth/log-in", {
      userName,
      password
    })
  }

  me() {
    return this.apiHelper.get("/api/v1/users/me")
  }

  forgotPassword(userName: string) {
    return this.apiHelper.post("/api/auth/forgot-password", {
      userName,
    })
  }

  resetPassword(token: string, password: string) {
    return this.apiHelper.post("/api/auth/reset-password", {
      token,
      password
    })
  }

  saveProfile(body: any) {
    return this.apiHelper.put("/api/v1/users/me", body)
  }

  setPassword(body: any) {
    return this.apiHelper.put("/api/v1/users/set-password", body)
  }
}
